/*
 * Copyright 2014-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */

'use strict';

var rest = require('./client/default'),
    browser = require('./client/xhr');

rest.setPlatformDefaultClient(browser);

module.exports = rest;



/*****************
 ** WEBPACK FOOTER
 ** ./~/rest/browser.js
 ** module id = 1732
 ** module chunks = 0
 **/